<template>
  <button
    type="button"
    class="bg-button-secondary-default flex items-center justify-between px-4 py-2"
    @click="show"
  >
    <span class="flex items-center space-x-3">
      <span class="bg-background-positive-primary/10 rounded-xl p-1">
        <img
          src="./assets/calendar.svg"
          width="24"
          height="24"
          role="presentation"
          alt=""
        />
      </span>
      <span class="flex flex-col items-start">
        <span class="text-text-neutral-primary font-semibold leading-snug">{{
          t('search.nearestSearchesRoundTrip.calendarPrice')
        }}</span>
        <span class="text-text-neutral-tertiary text-sm">{{
          t('search.nearestSearchesRoundTrip.lookOtherDates')
        }}</span>
      </span>
    </span>
    <ChevronIcon class="text-text-positive-primary h-6 w-6" />
  </button>
</template>

<script setup lang="ts">
  import { useI18n } from 'vue-i18n';

  import { analyticsEventsLib } from '@/shared/lib';

  import ChevronIcon from '@/assets/images/chevron-arrow-24x24.svg?component';

  import { roundTripSearchesBottomSheetController } from '../lib';

  const { t } = useI18n();
  const bottomSheetController = roundTripSearchesBottomSheetController();

  const show = () => {
    analyticsEventsLib.priceCalendarClick();
    bottomSheetController.show();
  };
</script>
